export const ApiRun = "https://staging-api-json.viabber.com/run";
export const ApiGetData = "https://staging-api-json.viabber.com/get-data";
export const ApiDataSource = "https://staging-api-json.viabber.com/datasource";
export const ApiFormat = "https://staging-api-json.viabber.com/format";
